import 'intersection-observer';
import 'custom-event-polyfill';
import 'picturefill';
import './polyfill';
import vueApp from './vueApp';
import hashScroll from './hashScroll';
import loading from './loading';
import header from './header';
import scrollIE from './scrollIE';
import slider from './slider';
import sortTag from './sortTag';
import navOTA from './navOTA';
import addLoopParameter from './addLoopParameter';

vueApp();
hashScroll();
loading();
header();
scrollIE();
slider();
sortTag();
navOTA();
addLoopParameter();
